module.exports = __webpack_public_path__ + "img/6.02a0f4ae.jpg";